import * as React from "react";
import { inject, observer } from "mobx-react";
import { UitkToast } from "uitk-react-toast";
import { UitkIcon } from "uitk-react-icons";
import { UIPageStore } from "stores/UIPageStore";

export interface NotificationProps {
  uiPage?: UIPageStore;
}

// Listens to the UIPageStore and display notifications
@inject("uiPage")
@observer
export class Notification extends React.Component<NotificationProps> {
  public render() {
    const { uiPage } = this.props;

    if (!uiPage || !uiPage.notification) {
      return null;
    }

    return (
      <UitkToast show={uiPage.notification.isVisible}>
        <div className="uitk-flex uitk-flex-align-items-center uitk-flex-gap-three">
          <span className="uitk-flex-child">
            <UitkIcon name={uiPage.notification.icon} />
          </span>
          <span className="uitk-flex-child">{uiPage.notification.message}</span>
        </div>
      </UitkToast>
    );
  }
}
